import { describeMutation } from '@siteless/resource';
import { doc, setDoc } from 'firebase/firestore';
import { database } from '../../config/firebase';
import AllBallotsResource from './All';
import BallotsCompletedResource from './Completed';
import OneBallotResource from './One';
import BallotsScoresResource from './Scores';
import { thisOscarsYear } from '../../config/constants';

export const updateBallotMutation = describeMutation(
  'updateBallot',
  async ({ userId, ballotItemKey, optionKey }) => {
    await OneBallotResource.yield(userId, (last) => ({
      ...last,
      [ballotItemKey]: optionKey,
    }));

    try {
      await setDoc(
        doc(database, `ballots_${thisOscarsYear}`, userId),
        {
          [ballotItemKey]: optionKey,
        },
        { merge: true },
      );
    } catch (error) {
      window.alert(error);
    }
  },
);

export const acceptExternalBallotChangesMutation = describeMutation(
  'acceptExternalBallotChanges',
  async (changes) => {
    AllBallotsResource.yield(undefined, (identity, last) => {
      if (!last) return last;
      return Object.keys(last).reduce(
        (acc, ballotUserId) => ({
          ...acc,
          [ballotUserId]: {
            ...(last[ballotUserId] || {}),
            ...(changes[ballotUserId] || {}),
          },
        }),
        {},
      );
    });

    OneBallotResource.yield(undefined, (ballotUserId, last) => {
      if (!last) return last;
      return {
        ...last,
        ...changes[ballotUserId],
      };
    });
  },
);

export const acceptScoreChangesMutation = describeMutation(
  'acceptScoreChanges',
  async (changes) => {
    let changesWithoutUndefinedScores = {};
    Object.keys(changes).forEach((key) => {
      if (
        changes[key].score !== undefined &&
        changes[key].strictScore !== undefined
      ) {
        changesWithoutUndefinedScores[key] = changes[key];
      }
    });

    await BallotsScoresResource.yield(undefined, (last) => ({
      ...last,
      ...changesWithoutUndefinedScores,
    }));
  },
);

export const acceptCompletedChangesMutation = describeMutation(
  'acceptCompletedChanges',
  async (changes) => {
    await BallotsCompletedResource.yield(undefined, (last) => ({
      ...last,
      ...changes,
    }));
  },
);
